import React, { useState,useEffect } from 'react'
// import "./forgetPassword.css"
import './LandingPage.css'
import axios from 'axios';
import { API_URL } from "../../services/config/endpoints"
import { AiFillMail } from "react-icons/ai";
import { RiLockPasswordFill } from "react-icons/ri"
import { IconContext } from "react-icons"
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export default function LandingForgetPassword(props) {
  console.log("landing forget password", props);
  let { ForgetModal, setForgetModal } = props
  let navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loader, setLoader] = useState(false)
const [userId,setUserId]=useState()
console.log('welcom',userId)

useEffect(() => {
let userData= localStorage.getItem('userId')
setUserId(userData)
}, [])
  const formik = useFormik({
    initialValues: {
      email: "",
      // password: "",
      // confirmPassword: "",


    },
    onSubmit: values => {
      setLoader(true)
      axios.post(`${API_URL}api/verification`, values)
        .then(res => console.log("values formik: ", res));
      toast.success('Check Your Inbox', {
        theme: 'colored'
      })
      navigate("/landing")
      setForgetModal(false)
      setLoader(false)
        .catch(err => console.log("values formik: ", err))

    },
    validate: values => {

      let errors = {}
      if (!values.email) {
        errors.email = 'Email Required'
      } else if (!/^[A-z0-9._%+-]+@[A-z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = 'Invalid Email Format'
      }
      // if (!values.password) {
      //   errors.password = 'New Password Required'

      // }

      // if (!values.confirmPassword) {
      //   errors.confirmPassword = 'Confirm Password Required'

      // }
      // if (values.confirmPassword !== values.password) {
      //   errors.confirmPassword = 'password and confirm password must be same'
      // }

      return errors

    }

  })
  const showPasswordHandler = () => {
    setShowPassword(!showPassword)
  }
  return (
    <div className="containerdivmodalforget p-2">
      {/* <div className="img-profile">
      </div> */}
      <div className=''>
        <form onSubmit={formik.handleSubmit}>
          <h2 className="register-heading" style={{ color: 'black', marginTop: '28px' }}>Forgot Password</h2>
          <div className="forg input-main">
            <div>
              <IconContext.Provider value={{ size: '16px' }}
              >  <span className="E"><AiFillMail /></span></IconContext.Provider>

              <input className="input-box" type="email" id='email' placeholder="Enter Email"
                value={formik.values.email} onChange={formik.handleChange} onBlur={formik.handleBlur}
              />
              {formik.touched.email && formik.errors.email ? <div className='error'>{formik.errors.email}</div> : null}
            </div>
            {/* <div>
              <span className="P"><RiLockPasswordFill /></span>

              <input className="input-box" type={showPassword ? "text" : "password"} id='password' placeholder="New Password"
                value={formik.values.password} onChange={formik.handleChange} onBlur={formik.handleBlur}
              />
              {formik.touched.password && formik.errors.password ? <div className='error'>{formik.errors.password}</div> : null}
            </div> */}
            {/* <div>
              <span className="P"><RiLockPasswordFill /></span>
              <input className="input-box" type={showPassword ? "tesxt" : "password"} id='confirmPassword' placeholder="Confirm password"
                value={formik.values.confirmPassword} onChange={formik.handleChange} onBlur={formik.handleBlur}
              />
              {formik.touched.confirmPassword && formik.errors.confirmPassword ? <div className='error'>{formik.errors.confirmPassword}</div> : null}
            </div> */}
            {/* <div className="show-password mt-3">
              <input
                type="checkbox"
                name="showPassword"
                id="showPassword"
                onClick={showPasswordHandler}
              />
              &nbsp;
              <label htmlFor="showPassword" style={{ color: 'black' }}>Show Password</label>
            </div> */}
          </div>
          <div className="subminte-btn-main">
            <button disabled={loader} className='submite-btn' type="submit">Verify</button>


          </div>


        </form>


      </div>

    </div>

  )
}
